type PhaseWithForms = {
  phaseForms?: { id?: string }[] | null;
};

type SurveyLinkWithPhase = {
  phase?: PhaseWithForms | null;
};

type PackageWithSurveyLinks = {
  surveyLinks?: SurveyLinkWithPhase[] | null;
};

/** True when at least one linked survey phase has ≥1 form. */
export function packageHasAssignableForms(
  pkg: PackageWithSurveyLinks | null | undefined
): boolean {
  return (pkg?.surveyLinks ?? []).some(
    (link) => (link.phase?.phaseForms?.length ?? 0) > 0
  );
}

/** True when the package has at least one linked survey. */
export function packageHasSurveyLinks(
  pkg: PackageWithSurveyLinks | null | undefined
): boolean {
  return (pkg?.surveyLinks ?? []).length > 0;
}

/**
 * True when the package has survey links, but at least one linked survey
 * has no forms (assignability / completeness warning).
 */
export function packageHasPhaseFormIssues(
  pkg: PackageWithSurveyLinks | null | undefined
): boolean {
  const links = pkg?.surveyLinks ?? [];
  if (links.length === 0) {
    return false;
  }
  return links.some((link) => (link.phase?.phaseForms?.length ?? 0) === 0);
}
